// extracted by mini-css-extract-plugin
export default {"wrapper":"tellStoryLanguage_wrapper__fpRRv","container":"tellStoryLanguage_container__qV96i","options":"tellStoryLanguage_options__DmXlU","option":"tellStoryLanguage_option__PFTqC"};